import { CtxMapV2 } from 'components/mapV2/contexts/CtxMapV2';
import { useContext, useEffect, useRef } from 'react';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    children: React.ReactNode;
    onHeightChanged: (height: string) => void;
}

export const MapV2ModalLayoutPc = (props: Props): JSX.Element => {
    const ctxMapV2 = useContext(CtxMapV2);

    const modalPcRef = useRef<HTMLDivElement>(null);

    const isExpanded = ctxMapV2.pcModalState.isExpanded;
    const isIframe = ctxMapV2.isIframe;

    useEffect(() => {
        if (modalPcRef.current?.clientHeight) {
            props.onHeightChanged(`${modalPcRef.current?.clientHeight}px`);
        }
    }, [modalPcRef.current, ctxMapV2.pcModalState.isExpanded, modalPcRef.current?.clientHeight]);

    useEffect(() => {
        function resizeHandler() {
            if (modalPcRef.current?.clientHeight) {
                props.onHeightChanged(`${modalPcRef.current?.clientHeight}px`);
            }
        }
        window.addEventListener('resize', resizeHandler);
        resizeHandler();
        return () => window.removeEventListener('resize', resizeHandler);
    }, []);

    return (
        <S_MapV2ModalLayoutPc
            ref={modalPcRef}
            className={props.className}
            $isExpanded={isExpanded}
            $isIframe={isIframe}
        >
            {props.children}
        </S_MapV2ModalLayoutPc>
    );
};

const S_MapV2ModalLayoutPc = styled.div<{
    $isExpanded: boolean;
    $isIframe: boolean;
}>`
    position: absolute;
    width: 375px;
    border-radius: 10px;
    z-index: 5;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    ${(props) => {
        if (props.$isIframe) {
            return css`
                top: 45px;
                right: 10px;
            `;
        }
        return css`
            top: 20px;
            right: 20px;
        `;
    }}

    ${(props) => {
        if (props.$isExpanded && props.$isIframe) {
            return css`
                bottom: 10px;
            `;
        }
        if (props.$isExpanded && !props.$isIframe) {
            return css`
                bottom: 20px;
            `;
        }
        return css`
            height: 134px;
        `;
    }}
`;
